import { Price } from "../../misc/price";
import { getExchangeRate } from "../orderEdit/getExchangeRate";
import { getSavedProductPrice } from "../orderEdit/orderToProducts";
import type { Currency } from "../../data/BaseEntity";
import type { OrderPriceValue } from "../ordersApi";

interface SavedOrder {
  readonly currency: Currency;
  readonly currencyExchangeRate?: number;
  readonly products: {
    readonly currency: Currency;
    readonly price: OrderPriceValue;
    readonly cancelled?: object;
  }[];
}

export function getOrderPrice(order: SavedOrder): Price {
  if (!order.currency) {
    return Price.invalid;
  }
  return order.products
    .filter((p) => !p.cancelled)
    .map((p) =>
      order.currency
        ? getSavedProductPrice(p.price, getExchangeRate(p.currency, order.currency, order.currencyExchangeRate))
        : Price.invalid,
    )
    .reduce((prev, curr) => prev.add(curr), new Price(0));
}
